module.exports = __webpack_public_path__ + "components/country-flag/static/es-ct-c0e951f7cac7908c20bde6629780c3e9.svg";